'use client';

import {
    COLLECTION_ZONE_LAYOUT,
    PRISMIC_ZONE_LAYOUT,
    RECENTLY_PLAYED_BANNER_ID,
    ZONE_SLICE_TYPES
} from '@/app/constants/zone';
import { GamesGridZone } from '@/app/components/zones/layouts/games-grid/games-grid-zone';
import { useRecentlyPlayedZone } from '@/hooks/use-recently-played-zone/use-recently-played-zone';
import { useGlobalContext } from '@/store/contexts/global-context';
import type { Zone } from '@/types/zones/zone';

import './styles/default.scss';

type RecentlyPlayedZoneProps = {
    initialZone: Zone;
    isOnlyChildZone: boolean;
    gridLayout?: PRISMIC_ZONE_LAYOUT;
};

export const RecentlyPlayedZone = ({
    initialZone,
    isOnlyChildZone,
    gridLayout = PRISMIC_ZONE_LAYOUT.DEFAULT
}: RecentlyPlayedZoneProps) => {
    const { isLoggedIn } = useGlobalContext();
    const zoneData = useRecentlyPlayedZone({ initialZone, gridLayout });

    if (!zoneData) {
        return null;
    }

    const hideGameInfo = gridLayout !== PRISMIC_ZONE_LAYOUT.DEFAULT || isLoggedIn;
    const zoneLayout = COLLECTION_ZONE_LAYOUT[gridLayout];

    return (
        <GamesGridZone
            games={zoneData.games}
            tracking={zoneData.tracking}
            gridLayout={gridLayout}
            isOnlyChildZone={isOnlyChildZone}
            hideGameInfo={hideGameInfo}
            meta={{
                title: zoneData.meta.title,
                categoryUid: zoneData.meta.categoryUid,
                zoneType: ZONE_SLICE_TYPES.RECENTLY_PLAYED_GAMES,
                bannerId: RECENTLY_PLAYED_BANNER_ID,
                zoneName: zoneData.meta.title ?? 'Recently played',
                zoneLayout,
                gridClassModifier: 'recently-played-zone',
                isDynamicOrdering: zoneData.meta.isDynamicOrdering
            }}
        />
    );
};
